import { RouterClass } from 'src/app/services/utils/router/router-class.routes';
import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
  {
    label: 'Agendas',
    icon: 'book',
    link: RouterClass.routerLinks.schedule.SETTINGS.join('/')
  },
  {
    label: 'Calendário',
    icon: 'calendar',
    link: RouterClass.routerLinks.calendar.VIEWS.join('/')
  },
  {
    label: 'Clínica',
    icon: 'plus',
    subMenus: [
      {
        subMenuItems: [
          {
            label: 'Pessoas',
            isTitle: true
          },
          {
            label: 'Pacientes',
            link: RouterClass.routerLinks.patient.PROFILE.join('/')
          },
          {
            label: 'Funcionários',
            link: RouterClass.routerLinks.employees.PROFILE.join('/')
          }
        ]
      },
      {
        subMenuItems: [
          {
            label: 'Convênios',
            link: RouterClass.routerLinks.insurances.SETTINGS.join('/')
          },
          {
            label: 'Fichas de prontuário',
            link: RouterClass.routerLinks.datasheets.PREVIEW.join('/')
          },
          {
            label: 'Procedimentos',
            link: RouterClass.routerLinks.procedures.LIST.join('/')
          },
        ]
      }
    ]
  }
]
